import { handleShowBookDemo, isOpenBookaDemo } from '../../../action';
import AnimButton from '../../Button/AnimButton';
import { useDispatch, useSelector } from 'react-redux';
import Meeting from './Meeting';
import { useEffect } from 'react';

const BookADemoTooltip = ({show}) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.reducer);

  // useEffect(() => {
  //   const script = document.createElement('script');
  //   script.src = "https://assets.calendly.com/assets/external/widget.js";
  //   script.async = true;
  //   document.body.appendChild(script);
  // }, [])
  const tooltipHandler = () => {
    if(state.const_var.crmSetting.main_domain_url === 'usesconstruction.com') {
      window.open('https://www.usesconstruction.com/contact-6', '_blank')
    } else {
      window.open('mailto:' + state.const_var.crmSetting.email, '_self')
    }
  }
  return (
     <>
      <div className='book-demo-tooltip'>
        <div className='info-text'>
          Connect with us at
        </div>
        {/*<div className='phone-container'>
          <div className='write-us' event={() => window.open('tel:' + state.const_var.crmSetting.phone_number, '_self')}>
            <span>{state.const_var.crmSetting.phone_number}</span>
          </div>
        </div>*/}
        <div className='book-demo-container'>
          <div className='write-us'><a href={"tel:" + state.const_var.crmSetting.phone_number}>
          <span className="write-us">{state.const_var.crmSetting.phone_number}</span></a></div>
        </div>

        <i className='icon-cross-ico' onClick={(e) => { e.stopPropagation(); dispatch(handleShowBookDemo()) }} ></i>
        <div className='book-demo-container'>
          <div>or</div><div className='write-us' onClick={tooltipHandler}>
            {state.const_var.crmSetting.main_domain_url === 'usesconstruction.com' ? 'Get a Quote' : 'Write to us'}
          </div>
        </div>
      </div>

      <Meeting meetingfor={state.modalfor} />
    </>  
  )
}

export default BookADemoTooltip